<div *ngIf="descriptor" class="vedrax-multiple-container">
    <mat-form-field>
        <mat-label>{{descriptor.controlLabel}}</mat-label>
        <mat-select (selectionChange)="onChange($event)">
            <mat-option *ngFor="let option of options" [value]="option">
                {{option.value}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-chip-list aria-label="Item selection">
        <mat-chip *ngFor="let item of selections" [selectable]="selectable" [removable]="removable"
            (removed)="remove(item.key)">
            {{item.value}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
    </mat-chip-list>
</div>